import { render, staticRenderFns } from "./VoucherCards.html?vue&type=template&id=82bc863c&external"
import script from "./VoucherCards.js?vue&type=script&lang=js&external"
export * from "./VoucherCards.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports